import { useEffect, useState } from "react";
import { informationsRucService } from "services";
import { useErrorHandler } from "utils/errorHandling";
import type { InformationRuc } from "models";

interface UseInformationsRucReturn {
  informationRuc?: InformationRuc;
  isLoading: boolean;
}

interface UseInformationsRucParams {
  communeId: string | undefined;
}

export function useInformationsRuc({
  communeId,
}: UseInformationsRucParams): UseInformationsRucReturn {
  const [informationRuc, setInformationRuc] = useState<InformationRuc>();
  const { catchErrors, isLoading } = useErrorHandler({
    dontThrow: true,
    defaultIsLoading: false,
  });

  useEffect(() => {
    setInformationRuc(undefined);
    if (communeId == null || communeId === "") {
      return;
    }
    void catchErrors(async () => {
      const res = await informationsRucService.getByCommuneId(communeId);
      setInformationRuc(res);
    });

    return () => {
      setInformationRuc(undefined);
    };
  }, [catchErrors, communeId]);

  return { informationRuc, isLoading };
}
